interface OriginalStructure {
  name?: string;
  slug?: string;
  logo_url?: string;
  font_config?: {
    titles?: string;
    paragraphs?: string;
  };
  color_style_config?: {
    paragraph_text?: string;
    accent_color?: string;
    link_color?: string;
    button?: string;
    button_click?: string;
    button_text?: string;
    background?: string;
    error_dialog?: string;
    watch_background?: string;
  };
  id?: string;
  environment_id?: string;
  timestamp?: string;
}

interface ConvertedStructure {
  id: string;
  environmentId: string;
  name: string;
  slug: string;
  logoUrl: string;
  fontTitle: string;
  fontParagraph: string;
  colorParagraphText: string;
  colorAccent: string;
  colorLink: string;
  colorButton: string;
  colorButtonClick: string;
  colorButtonText: string;
  colorBackground: string;
  colorErrorDialog: string;
  colorWatchBackground: string;
}

export function convertStructure(
  original: OriginalStructure,
): ConvertedStructure {
  return {
    id: original.id || '',
    environmentId: original.environment_id || '',
    name: original.name || '',
    slug: original.slug || '',
    logoUrl: original.logo_url || '',
    fontTitle: original.font_config?.titles || '',
    fontParagraph: original.font_config?.paragraphs || '',
    colorParagraphText: original.color_style_config?.paragraph_text || '',
    colorAccent: original.color_style_config?.accent_color || '',
    colorLink: original.color_style_config?.link_color || '',
    colorButton: original.color_style_config?.button || '',
    colorButtonClick: original.color_style_config?.button_click || '',
    colorButtonText: original.color_style_config?.button_text || '',
    colorBackground: original.color_style_config?.background || '',
    colorErrorDialog: original.color_style_config?.error_dialog || '',
    colorWatchBackground: original.color_style_config?.watch_background || '',
  };
}
